import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {sendGameMessage} from "store/actions/game";
import {ACTION_TYPE} from "utils";
import View from "./View";

export default function Container() {
  const dispatch = useDispatch();

  useEffect(() => {
    const joystick = document.querySelector("#joystick");
    const jumpButton = document.querySelector("#joystick_button_J");

    if (joystick) {
      joystick.style.visibility = "hidden";
    }

    if (jumpButton) {
      jumpButton.style.visibility = "hidden";
    }
  }, []);

  const onClickHome = () => {
    window.location.reload();
  };

  const onClickReplay = () => {
    dispatch(
      sendGameMessage({
        type: ACTION_TYPE.SEND_GAME_MESSAGE,
        message: {type: "RETRY_GAME"},
      }),
    );

    const joystick = document.querySelector("#joystick");
    const jumpButton = document.querySelector("#joystick_button_J");

    if (joystick) {
      joystick.style.visibility = "visible";
    }

    if (jumpButton) {
      jumpButton.style.visibility = "visible";
    }
  };

  return <View onClickHome={onClickHome} onClickReplay={onClickReplay} />;
}
